import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import * as actions from '../actions/Programs';
import { getUsersByRole } from '../actions/Users';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import GridHeader from '../components/common/GridHeader';
import DeleteConfirmation from '../components/MultiDeleteConfirmation';
import { DataGrid } from '@mui/x-data-grid';
import { Checkbox, Label } from '@material-ui/core';

const Programs = (props) => {
    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [showMyCases, setShowMyCases] = useState(true);

    useEffect(() => {
        props.actions.getUsersByRole('');
        if (showMyCases)
            props.actions.toggleGetProgramsByPersonId(props.context.getIn(['user', 'personId']), showMyCases);
        else 
            props.actions.getPrograms();
    }, [showMyCases, props.actions, props.context]);

    const handleSelect = (e) => {
        props.actions.getProgram(e.id);
        props.history.push(`/programs/program/${e.id}`, { id: e.id })
    };

    const handleAddClick = (e) => {
        props.actions.newProgram();
        props.history.push('/programs/program', { 
            newProgram: true
        });
    }

    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

    const handleDelete = () => {
        const personId = props.context.getIn(['user', 'personId'])
        props.actions.deletePrograms(deleteConfirmationState.toDelete.map(x => x.programId), showMyCases, personId);
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }

    const handleSelectionChanged = (e) => {
        if (e.length > 0) {
            setDeleteConfirmationState({
                display: false,
                toDelete: props.programs.filter(x => e.find(y => y === x.get('programId'))).toJS(),
            });
            setDeleteEnabled(true);
        }
        else
            setDeleteEnabled(false);
    }

    const customHeader = <>
        <Checkbox style={{ height: '.4em', marginLeft: '1em', marginTop: '.2em' }} id='toggleByPersonId' onChange={() => setShowMyCases(!showMyCases)} checked={showMyCases} />
        <label style={{ fontSize: 'small', marginTop: '.3em' }}>My Cases
        </label>
    </>

    return (
        <Container>
            <Row className='mb-1'>
                <GridHeader
                    gridEntities='Projects'
                    customHeaderButton={customHeader}
                    deleteButtonId='deleteProgramButton'
                    disableDelete={!deleteEnabled}
                    onDeleteClick={handleDeleteClick}
                    addButtonId='addProgramButton'
                    onAddClick={handleAddClick}
                    addTooltipTarget={'addProgramButton'}
                    deleteTooltipTarget={'deleteProgramButton'}
                    tooltipEntity={"Project"}
                />
            </Row>
            <Row className='mb-1'>
                <Col>
                    <div className='ag-theme-balham' style={{ width: 'auto' }}>
                        <DataGrid
                            rows={props.programs.toJS().map(x => { return { id: x.programId, ...x } })}
                            checkboxSelection
                            onRowDoubleClick={handleSelect}
                            onRowSelectionModelChange={handleSelectionChanged}
                            autoHeight={true}
                            rowHeight={41}
                            initialState={{
                                pagination: { paginationModel: { pageSize: 20 } },
                            }}
                            columns={[
                                {
                                    headerName: 'Projects',
                                    field: 'name',
                                    filter: true,
                                    sortable: true,
                                    checkboxSelection: true,
                                    flex: 3,
                                },
                                {
                                    headerName: 'Court / Jurisdiction',
                                    field: 'jurisdictionFullName',
                                    flex: 3,
                                },
                                {
                                    headerName: 'Court Type',
                                    field: 'courtType',
                                    flex: 3,

                                },
                                {
                                    headerName: 'Assigned To',
                                    field: 'assignedTo',
                                    flex: 3,
                                    valueGetter: (params) => {
                                        const projectAssignedTo = props.users && props.users.userList.filter(e => e.personId === params.row.projectDirectorId);
                                        return projectAssignedTo.length > 0 && projectAssignedTo[0].displayName
                                            ? projectAssignedTo[0].displayName
                                            : '';
                                    },
                                }
                            ]}
                            sx={{
                                backgroundColor: 'white'
                            }}
                            getRowClassName={(params) => 'grid-row'}
                        />
                    </div>
                </Col>
            </Row>
            <DeleteConfirmation
                histroy={props.history}
                title={`Delete Program`}
                onDelete={handleDelete}
                onToggle={handleDeleteConfirmationToggle}
                toDelete={deleteConfirmationState.toDelete.map(x => x.name)}
                isOpen={deleteConfirmationState.display}
            />
        </Container>
    );
}

function mapStateToProps(state, ownProps) {
    return {
        programs: state.Programs,
        users: state.Users.toJS()
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions, getUsersByRole }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Programs);